import { ReleaseNoteSectionViewOf } from 'bff';
import { InlineText } from '../RichText';

const ActionChip = ({ label }: { label: string }) => (
  <span className='shrink-0 whitespace-nowrap rounded-lg border border-primary/30 px-2.5 py-1 text-xs font-bold text-primary'>
    {label}
  </span>
);

export const CardsSection = ({
  section: { content },
}: {
  section: ReleaseNoteSectionViewOf<'cards'>;
}) => (
  <div className='grid gap-3 sm:grid-cols-2 lg:grid-cols-3'>
    {content.cards.map((card) => (
      <div
        key={card.title}
        className='flex flex-col overflow-hidden rounded border border-stone-200 bg-white'
      >
        <h4 className='border-b border-stone-200 bg-stone-50 px-4 py-3 text-[0.9375rem] font-bold text-foreground'>
          {card.title}
        </h4>
        {card.body && (
          <p className='p-4 text-sm leading-relaxed text-stone-600'>
            <InlineText text={card.body} />
          </p>
        )}
        {card.rows && (
          <ul className='divide-y divide-stone-100'>
            {card.rows.map((row) => (
              <li
                key={row.title}
                className='flex items-center justify-between gap-3 px-4 py-3'
              >
                <div className='flex min-w-0 flex-col gap-0.5'>
                  <p className='text-sm text-foreground'>{row.title}</p>
                  <p className='text-xs leading-relaxed text-muted-foreground'>
                    <InlineText text={row.body} />
                  </p>
                </div>
                {row.action && <ActionChip label={row.action} />}
              </li>
            ))}
          </ul>
        )}
      </div>
    ))}
  </div>
);
